import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export const useSegmentSliderStoreData = () => {
  const { current: session } = useSelector((state: RootState) => state.sessions);
  const { selected: client } = useSelector((state: RootState) => state.clients);
  const { list: treatmentPlanGoals } = useSelector((state: RootState) => state.goals);
  const { user } = useSelector((state: RootState) => state.auth);

  return {
    session,
    client,
    treatmentPlanGoals,
    user,
  };
};
